import { render, staticRenderFns } from "./Summaryorderview.vue?vue&type=template&id=56f39796&scoped=true"
import script from "./Summaryorderview.vue?vue&type=script&lang=js"
export * from "./Summaryorderview.vue?vue&type=script&lang=js"
import style0 from "./Summaryorderview.vue?vue&type=style&index=0&id=56f39796&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f39796",
  null
  
)

export default component.exports